import gql from 'graphql-tag';

export const QUERY_GET_ME = gql`
  query Me {
    getMe {
      id
      firstname
      lastname
      email
      admin
      type
      experience
    }
  }
`;

export const QUERY_GET_USERS = gql`
  query getPersons {
    getPersons {
      id
      archived
      firstname
      lastname
      email
    }
  }
`;

export const MUTATION_ARCHIVE_USER = gql`
  mutation archivePerson($personId: ID!) {
    archivePerson(personId: $personId)
  }
`;

export const MUTATION_UNARCHIVE_USER = gql`
  mutation unarchivePerson($personId: ID!) {
    unarchivePerson(personId: $personId)
  }
`;
